import React, { useCallback } from 'react';
import shallowequal from 'shallowequal';
import { ExpandIconProps } from './iExpandIcon';
import { DefaultRecordType } from './interface';
import ReactDOMCompat from '../../wui-core/src/reactCompat';

const ExpandIcon: React.FC<ExpandIconProps<DefaultRecordType>> = React.memo((props) => {
    const {
        expandable,
        clsPrefix,
        onExpand,
        needIndentSpaced,
        expanded,
        record,
        // index,
        isShowExpandIcon,
        expandedIcon,
        collapsedIcon,
        expandIcon,
        fixedIndex,
        fieldid,
        oldMode
    } = props;

    const handleExpand = useCallback((status: boolean, record?: DefaultRecordType, fixedIndex?: number, e?: React.MouseEvent<HTMLElement>) => {
        e && e.stopPropagation();
        onExpand && onExpand(status, record, fixedIndex, e);
    }, [onExpand]);

    if (expandable && isShowExpandIcon) {
        const expandClassName = expanded ? 'expanded' : 'collapsed';
        let fieldidAttr = fieldid ? { fieldid: 'switch_icon' } : {};
        let className = `${clsPrefix}-expand-icon ${clsPrefix}-${expandClassName}`;
        let currentIcon: React.ReactNode;
        if (expanded && (expandedIcon || expandIcon)) {
            if (typeof expandIcon === 'function') {
                currentIcon = expandIcon({ expanded, onExpand, record });
            } else {
                currentIcon = expandedIcon as JSX.Element;
            }
        } else if (!expanded && (collapsedIcon || expandIcon)) {
            if (typeof expandIcon === 'function') {
                currentIcon = expandIcon({ expanded, onExpand, record });
            } else {
                currentIcon = collapsedIcon as JSX.Element;
            }
        } else {
            currentIcon = <span className={className} {...fieldidAttr} />;
        }
        return (
            <span
                onClick={(e) => ReactDOMCompat.startTransition(() => handleExpand(!expanded, record, fixedIndex, e))}
                className="expand-icon-con"
            >
                {currentIcon}
            </span>
        );
    } else if ((needIndentSpaced && !isShowExpandIcon) || oldMode) {
        return <span className={`${clsPrefix}-expand-icon ${clsPrefix}-spaced`} />;
    }
    return null;
}, (prevProps, nextProps) => shallowequal(prevProps, nextProps));

export default ExpandIcon;
